import type { CityConfig } from "../city-template/types";

export const rentonConfig: CityConfig = {
  city: "Renton",
  state: "Washington",
  stateAbbr: "WA",
  slug: "renton",
  route: "/cities/renton",
  title: "Emergency Passport Renton WA | Expedited Passport Processing | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Renton, Washington — as fast as 24 hours. Fast passport renewal and new passport applications for Renton, Tukwila, Kent, and all South King County residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Renton, WA",
  heroSubtitle: "Renton travelers — from Boeing employees to Lake Washington families to South King County professionals — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of South King County and the Renton-Kent-Auburn corridor.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20aerial%20view%20of%20Renton%20Washington%20with%20Boeing%20737%20assembly%20plant%20on%20the%20south%20shore%20of%20Lake%20Washington%2C%20the%20Renton%20skyline%20with%20modern%20buildings%2C%20Gene%20Coulon%20Memorial%20Beach%20Park%20with%20waterfront%20views%2C%20lush%20evergreen%20forests%20surrounding%20the%20city%2C%20warm%20golden%20afternoon%20sunlight%2C%20South%20King%20County%20Pacific%20Northwest%20atmosphere%2C%20professional%20city%20photography%20without%20text%20or%20people&width=1800&height=700&seq=renton-hero-001&orientation=landscape",
  heroImageAlt: "Renton Washington with Boeing plant and Lake Washington waterfront",
  geoPosition: "47.4797;-122.2079",
  geoPlacename: "Renton, Washington",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Seattle Passport Agency",
    address: "300 5th Ave, Suite 600, Seattle, WA 98104",
    distance: "Approximately 12 miles north of Renton via I-5 or I-405",
  },
  nearbyCitiesZips: [
    { name: "Renton", zips: "98055, 98056, 98057, 98058, 98059" },
    { name: "Tukwila", zips: "98108, 98138, 98168, 98178, 98188" },
    { name: "Kent", zips: "98030, 98031, 98032, 98035, 98042, 98064, 98089" },
    { name: "Newcastle", zips: "98056, 98059" },
    { name: "SeaTac", zips: "98148, 98158, 98168, 98188, 98198" },
    { name: "Burien", zips: "98146, 98148, 98166, 98168" },
    { name: "Des Moines", zips: "98148, 98158, 98198" },
    { name: "Normandy Park", zips: "98148, 98166" },
    { name: "Skyway", zips: "98178" },
    { name: "Bryn Mawr", zips: "98178" },
    { name: "Fairwood", zips: "98058" },
    { name: "Maple Valley", zips: "98038" },
    { name: "Covington", zips: "98042" },
    { name: "Auburn", zips: "98001, 98002, 98092, 98071" },
    { name: "Federal Way", zips: "98003, 98023, 98063, 98093" },
    { name: "Enumclaw", zips: "98022" },
    { name: "Black Diamond", zips: "98010" },
    { name: "Hobart", zips: "98025" },
    { name: "Ravensdale", zips: "98051" },
    { name: "Issaquah", zips: "98027, 98029, 98075" },
    { name: "Bellevue", zips: "98004, 98005, 98006, 98007, 98008" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Seattle Passport Agency — just 15 minutes up I-5 or I-405" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-flight-takeoff-line", title: "Minutes from SEA Airport", desc: "Renton is the closest major suburb to Seattle-Tacoma International Airport" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from any South King County location" },
  ],
  internalLinks: [
    { name: "Expedited passport in Seattle, WA", route: "/cities/seattle" },
    { name: "Emergency passport help in Bellevue, WA", route: "/cities/bellevue" },
    { name: "Urgent passport services in Tacoma, WA", route: "/cities/tacoma" },
    { name: "Washington passport services overview", route: "/states/washington" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Renton, Washington remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Seattle Passport Agency (300 5th Ave, Suite 600, Seattle, WA 98104) — just 15 minutes north via I-5 or I-405. Renton residents can ship from any UPS or FedEx in South King County.",
  fpcOfficeAddress: "5608 17th Avenue NW, Seattle, WA 98107",
  fpcOfficeDistance: "Serving Renton, Tukwila, Kent, Newcastle, SeaTac, Burien, Des Moines, Normandy Park, Skyway, Fairwood, Maple Valley, Covington, and all of South King County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Renton and South King County. From the Boeing 737 assembly plant on the Lake Washington shoreline to the retail hub at The Landing, from the residential neighborhoods of Fairwood and the Renton Highlands to the industrial corridor along the Green River — we serve all of Renton and the surrounding communities.",
  nearbyCitiesIntro: "We serve Renton and all nearby communities including Tukwila, Kent, Newcastle, SeaTac, Burien, Des Moines, Normandy Park, Skyway, Fairwood, Maple Valley, Covington, Auburn, Federal Way, and Enumclaw. We also serve South Seattle, Eastside, and northern Pierce County communities.",
  howItWorksIntro: "Most Renton travelers complete everything online and ship documents overnight. No need to drive north to Seattle — our couriers handle the agency delivery and always pick the fastest route.",
  mistakesIntro: "Renton is a major South King County hub with significant travel demand from Boeing employees, SEA airport workers, and families. Here are the most common passport mistakes we see from Renton-area travelers.",
  testimonialsIntro: "Renton travelers — from Boeing professionals to Lake Washington families to suburban commuters — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Renton, WA? Here are the most common ones we hear from South King County travelers.",
  statePageRoute: "/states/washington",
  statePageName: "Washington",
  dmvWebsite: "https://www.dol.wa.gov",
  dmvLabel: "Washington DOL — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to downtown Seattle", "Parking and traffic in downtown Seattle"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Seattle Passport Agency — close South King County proximity", "No downtown parking or traffic hassle", "Perfect for Boeing and SEA airport travel deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Seattle Passport Agency — close South King County proximity", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Renton travelers with immediate departure needs — as fast as 24 hours. Our couriers use the Seattle Passport Agency. Perfect for Boeing business travel, last-minute vacations, and family emergencies.",
      bullets: ["24–48 hour turnaround available", "Seattle Passport Agency — close South King County courier", "Boeing and SEA airport travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Renton adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your South King County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Renton residents and families — including Boeing families, new citizens, and South King County residents.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Renton residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Renton and South King County families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Renton and South King County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Renton WA", description: "Urgent passport processing for Renton Washington travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Renton WA", description: "Fast passport renewal for Renton Washington residents with a previously-issued passport." },
    { name: "First-Time Passport Renton WA", description: "New passport application services for Renton Washington residents applying for their first passport." },
    { name: "Child Passport Renton WA", description: "Minor passport services for Renton Washington families with children under 16." },
  ],
  testimonials: [
    {
      name: "Michael R.",
      location: "Renton, WA",
      rating: 5,
      text: "Boeing business trip to Dubai with 6 days notice and my passport was expired. Fast Passport Center had my renewed passport in 2 days. I shipped from the UPS Store in The Landing and the whole process was seamless. Outstanding.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Amanda L.",
      location: "Kent, WA",
      rating: 5,
      text: "Family trip to Mexico with 8 days notice. Three passports — one adult renewal and two first-time for our kids. Done in 5 days. We shipped from FedEx on West Valley Highway and everything was perfect.",
      service: "Family Passport Bundle",
    },
    {
      name: "Craig T.",
      location: "Renton, WA",
      rating: 5,
      text: "Conference in London with 10 days notice. Fast Passport Center walked me through every step and had my passport in 3 days. The courier service is an absolute game-changer for South King County.",
      service: "Emergency Passport",
    },
    {
      name: "Lisa P.",
      location: "Newcastle, WA",
      rating: 5,
      text: "Lost my passport the week before a cruise to Alaska. Fast Passport Center replaced it in 48 hours. With SEA airport just 10 minutes away, I was ready to fly the next day.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "ren-1",
      name: "Renton Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "17200 116th Ave SE",
      city: "Renton",
      state: "WA",
      zip: "98058",
      phone: "(425) 226-3955",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Renton, near The Landing area",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Renton acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to downtown Renton and The Landing retail area.",
      icon: "ri-mail-line",
    },
    {
      id: "ren-2",
      name: "Renton Highlands Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4301 NE 4th St",
      city: "Renton",
      state: "WA",
      zip: "98059",
      phone: "(425) 255-5537",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Renton Highlands, approximately 3 miles northeast of downtown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Renton Highlands, Newcastle, and east Renton residents. Ample parking available.",
      icon: "ri-mail-line",
    },
    {
      id: "ren-3",
      name: "Kent Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10612 SE 240th St",
      city: "Kent",
      state: "WA",
      zip: "98031",
      phone: "(253) 852-3301",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Kent, approximately 6 miles south of downtown Renton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Kent, Covington, and south King County communities. Good alternative for south-side travelers.",
      icon: "ri-mail-line",
    },
    {
      id: "ren-4",
      name: "Tukwila Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "12826 48th Ave S",
      city: "Tukwila",
      state: "WA",
      zip: "98168",
      phone: "(206) 241-1059",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Tukwila, approximately 4 miles west of downtown Renton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Tukwila, SeaTac, and west Renton residents. Near Southcenter Mall.",
      icon: "ri-mail-line",
    },
    {
      id: "ren-5",
      name: "King County Clerk — Seattle",
      type: "County Clerk Passport Acceptance",
      address: "516 3rd Ave, Room W-105",
      city: "Seattle",
      state: "WA",
      zip: "98104",
      phone: "(206) 477-3080",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Downtown Seattle Courthouse — 15 minutes north via I-5",
      website: "https://www.kingcounty.com/depts/courts/clerk.aspx",
      websiteLabel: "King County Clerk",
      notes: "County Clerk passport acceptance. Extended hours compared to post office. Renton residents may prefer the Renton or Kent post offices for convenience.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — I-5 traffic to downtown Seattle", fpc: "No — ship from Renton" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Boeing & Aviation Travel", agency: "No special guidance", fpc: "Yes — aerospace and SEA airport expertise" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Renton Boeing employees and SEA airport workers often discover passport issues just before international assignments. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services at The Landing or along Rainier Avenue sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at King County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early Enough",
      description: "Renton Post Office appointments fill during summer travel and Boeing business travel peaks. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-road-map-line",
      title: "Underestimating I-5/I-405 Traffic to Seattle",
      description: "Many Renton residents attempt to drive to the Seattle passport agency in an emergency. I-5 and I-405 traffic can turn a 15-minute trip into 45+ minutes — our courier service is faster and more reliable.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming 4–6 Weeks Is Enough",
      description: "Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service. Alaska cruise season from Seattle peaks May–September — plan ahead.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in the Renton area or South King County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Renton, Kent, or Tukwila." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Seattle Passport Agency — leveraging the close South King County proximity." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Renton address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Renton, WA?", a: "Fast Passport Center offers emergency passport processing in Renton, Washington in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Seattle Passport Agency (300 5th Ave, Suite 600, Seattle, WA 98104) — just 15 minutes north via I-5 or I-405." },
    { q: "Does Renton have its own passport agency?", a: "No — Renton does not have a regional passport agency. The nearest facility is the Seattle Passport Agency (approximately 15 minutes north via I-5 or I-405). Fast Passport Center's courier service means Renton residents never need to deal with downtown Seattle traffic and parking." },
    { q: "Can I get an expedited passport in Kent, Tukwila, or Newcastle?", a: "Absolutely. Fast Passport Center serves all of South King County including Kent, Tukwila, Newcastle, SeaTac, Burien, Des Moines, Auburn, and Federal Way. Our service works the same way everywhere." },
    { q: "What airport do Renton travelers use for international flights?", a: "Seattle-Tacoma International Airport (SEA) is the primary airport for Renton and South King County. SEA is 5–10 minutes from Renton via I-5 and offers nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Alaska Airlines and Delta Air Lines are major hubs. Always verify passport validity for at least 6 months past your return date." },
    { q: "Can I use the Seattle passport agency for Alaska cruise travel?", a: "Yes. The Seattle Passport Agency processes emergency passports for Alaska cruise travelers with confirmed departures within 14 days. Seattle is the #1 Alaska cruise departure port in the United States. Renton is one of the closest suburbs to SEA and the cruise terminals." },
    { q: "How much does an expedited passport cost in Renton, WA?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Renton?", a: "Walgreens, CVS, and Bartell Drugs stores throughout Renton and Kent offer passport photos. UPS Store and FedEx Office locations at The Landing also provide them. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve Boeing employees in Renton?", a: "Yes. Fast Passport Center serves all of South King County including Boeing employees and their families. We understand aerospace industry travel schedules and can accommodate urgent international assignments. Our courier service is especially valuable for busy Boeing professionals." },
  ],
  photoLocations: [
    { name: "Walgreens — Rainier Avenue", address: "601 Rainier Ave S, Renton, WA 98057", hours: "Mon–Sun: 7AM–10PM" },
    { name: "Bartell Drugs — The Landing", address: "924 N 10th St, Renton, WA 98057", hours: "Mon–Sun: 7AM–10PM" },
    { name: "UPS Store — Renton Highlands", address: "4300 Talbot Rd S, Renton, WA 98055", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Tukwila Southcenter", address: "300 Andover Park W, Tukwila, WA 98188", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "WA DOL — Renton", address: "1314 Union Ave NE, Renton, WA 98059", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Washington Department of Licensing for driver's licenses, REAL ID, and vehicle registration. Online appointments strongly recommended.", featured: true },
    { name: "WA DOL — Kent", address: "25410 74th Ave S, Kent, WA 98032", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Serves Kent and south King County. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "SEA",
      name: "Seattle-Tacoma International Airport",
      distance: "5–10 minutes from Renton via I-5",
      address: "17801 International Blvd, Seattle, WA 98158",
      note: "Primary airport for Renton and South King County. Nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Alaska Airlines and Delta Air Lines hub. Renton is one of the closest suburbs to SEA Airport.",
      flightUrl: "https://www.portseattle.org/sea-tac",
      flightLabel: "SEA Flight Info",
      featured: true,
    },
    {
      code: "BFI",
      name: "King County International Airport (Boeing Field)",
      distance: "Adjacent to Renton — approximately 5 miles via I-405",
      address: "7277 Perimeter Rd S, Seattle, WA 98108",
      note: "General aviation and cargo airport adjacent to the Renton Boeing plant. Not used for commercial passenger travel. Serves Boeing corporate aviation.",
      flightUrl: "https://www.kingcounty.gov/depts/transportation/kcia.aspx",
      flightLabel: "BFI Info",
      featured: false,
    },
    {
      code: "RNT",
      name: "Renton Municipal Airport",
      distance: "Located in Renton — at the Boeing 737 plant on Lake Washington",
      address: "616 W Perimeter Rd, Renton, WA 98057",
      note: "General aviation airport adjacent to the Boeing Renton Factory. Primarily serves Boeing corporate aviation and general aviation. Not used for commercial passenger travel.",
      flightUrl: "https://www.rentonwa.gov/",
      flightLabel: "RNT Info",
      featured: false,
    },
  ],
};